<template>
  <div v-if="visible" class="modal-backdrop">
    <div class="modal-content p-4 rounded shadow">
      <h5 class="mb-3">{{ t('lead_modal.lead_modal.title') }}</h5>

      <p class="text-muted small mb-3">
        {{ t('lead_modal.lead_modal.subtitle') }}
      </p>

      <input
        v-model="name"
        :placeholder="t('lead_modal.lead_modal.name')"
        class="form-control mb-2"
      />

      <input
        v-model="contact"
        :placeholder="t('lead_modal.lead_modal.contact')"
        class="form-control mb-2"
      />

      <textarea
        v-model="message"
        :placeholder="t('lead_modal.lead_modal.message')"
        class="form-control mb-3"
        rows="2"
      />

      <div class="d-flex justify-content-end">
        <button class="btn btn-secondary me-2" @click="$emit('close')">
          {{ t('lead_modal.lead_modal.cancel') }}
        </button>

        <button
          class="btn btn-primary"
          :disabled="loading"
          @click="submit"
        >
          {{ loading ? t('lead_modal.lead_modal.sending') : t('lead_modal.lead_modal.submit') }}
        </button>
      </div>

      <div
        v-if="success"
        class="alert alert-success mt-3"
      >
        {{ t('lead_modal.lead_modal.success') }}
      </div>

      <div
        v-if="error"
        class="alert alert-danger mt-3"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  propertyId: { type: Number, required: true },
  visible: { type: Boolean, required: true }
})

const emit = defineEmits(['close'])

const name = ref('')
const contact = ref('')
const message = ref('')
const loading = ref(false)
const success = ref(false)
const error = ref(null)

const submit = async () => {
  loading.value = true
  error.value = null
  success.value = false

  try {
    const res = await fetch('/api/v1/leads', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token':
          document.querySelector('meta[name="csrf-token"]')?.content || ''
      },
      body: JSON.stringify({
        lead: {
          name: name.value,
          contact: contact.value,
          message: message.value,
          property_id: props.propertyId
        }
      })
    })

    const data = await res.json()

    if (res.ok) {
      success.value = true
      name.value = ''
      contact.value = ''
      message.value = ''
    } else {
      error.value = data.error || t('lead_modal.error_unknown')
    }
  } catch (e) {
    error.value = e.message
  } finally {
    loading.value = false
  }
}

// авто-закрытие
watch(success, (val) => {
  if (val) {
    setTimeout(() => {
      emit('close')
      success.value = false
    }, 2000)
  }
})
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  width: 400px;
}
</style>
